<template>
  <div id="Launch">
    <p>{{ message || "你无权观看此直播，请联系管理员"}}</p>
  </div>
</template>
<script>
import tool from "../../kits/Tools.js";
export default {
  data() {
    return {
      currentCount: 3,
      timer: "",
      imgScr: "",
      ds_id: "",
      timer2: "",
    };
  },
  props: ["loaded","message"],
  mounted() {

  },
  methods: {
    enterHome() {
    
    },
  },
};
</script>

<style scoped>
#Launch {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 11000;
  background: #f5f5f5;
  top: 0;
  left: 0;
}

.img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
}

.timeDown {
  position: absolute;
  right: 15px;
  top: 15px;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 12px;
  color: white;
}

p {
  padding: 100px 0;
  text-align: center;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// tipsView.vue?52f20f07